import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="bg-gradient-to-br from-navy-800 to-navy-950 border border-purple-500/30 rounded-[2.5rem] p-8 md:p-14 text-center relative overflow-hidden shadow-2xl" data-id="element-112">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-purple-600/10 blur-3xl pointer-events-none" data-id="element-113" />

          <div className="relative z-10" data-id="element-114">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-purple-500/10 mb-8" data-id="element-115">
              <ShieldCheck className="w-12 h-12 text-purple-400" data-id="element-116" />
            </div>

            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-117">
              GARANTÍA TOTAL DE 7 DÍAS
            </h2>

            <p className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-118">
              Descarga el MegaPack, revisa los libros, escucha los audios y mira
              el material.
              <br data-id="element-119" />
              <br data-id="element-120" />
              Si sientes que no es la herramienta adecuada para ayudar a tu
              hijo, envíanos un correo y te devolveremos el 100% de tu dinero.
              <br data-id="element-121" />
              <span className="text-purple-300 font-bold block mt-4 text-2xl" data-id="element-122">
                Sin preguntas. Sin riesgo.
              </span>
            </p>

            <div className="inline-block bg-navy-950 px-6 py-3 rounded-full border border-navy-800 text-sm font-medium text-slate-400" data-id="element-123">
              Tu inversión está completamente protegida.
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}